import { CSSObject } from "@emotion/react";

import { contentCss } from "./CellList.style";

interface CellListProps {
  values?: string[];
  label?: string;
  __css?: CSSObject;
}

const CellList = ({ values = [], label = "", __css = {} }: CellListProps) => {
  const isSingleValue = values.length === 1;
  const content = isSingleValue ? values[0] : `${values.length} ${label}`;
  const css = isSingleValue ? __css : contentCss;
  return <span css={css}>{content}</span>;
};

export default CellList;
